<template>
  <div class="row no-gutters align-items-center">
    <div class="col light-background rounded-left">
      <select class="pl-2 right-chevron" v-model="filterProps.dateRangeType">
        <option value="creation">{{
          $t("reports.supplier-reports-search.creation-date-range")
        }}</option>
        <option value="departure">{{
          $t("reports.supplier-reports-search.departure-date-range")
        }}</option>
      </select>
    </div>
    <div class="col light-background">
      <select
        class="pl-2 right-chevron"
        name="country"
        v-model="filterProps.country"
        :title="$t('reports.trip-reports-search.country')"
      >
        <option value="">{{
          $t("reports.trip-reports-search.country")
        }}</option>
        <option
          v-for="(country, index) in countries"
          :value="country.id"
          :key="index"
          >{{ country["name_" + $i18n.locale.toUpperCase()] }}</option
        >
      </select>
    </div>
    <div class="col light-background rounded-right">
      <input
        type="number"
        v-model="filterProps.createdFrom"
        class="form-control"
      />
    </div>
    <div class="col light-background rounded-right">
      <input
        type="number"
        v-model="filterProps.createdUntil"
        class="form-control"
      />
    </div>
    <div class="col-1 text-right">
      <button @click="resetForm" class="btn btn-sm btn-primary">
        {{ $t("reports.supplier-reports-search.reset-form") }}
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ReservationPerson from '@/services/hatsApi/ReservationPerson'
import Geo from '@/services/hatsApi/Geo'

export default {
  data () {
    return {
      resetFormKey: false,
      filterProps: {
        dateRangeType: 'creation',
        reference: '',
        serviceCode: '',
        status: '',
        serviceTypeId: '',
        user: '',
        country: '',
        createdFrom: this.dateFrom,
        createdUntil: this.dateUntil
      },
      users: [],
      countries: []
    }
  },
  props: {
    dateFrom: {
      default: moment().format('YYYY'),
      type: String,
      required: false
    },
    dateUntil: {
      default: moment().format('YYYY'),
      type: String,
      required: false
    }
  },
  watch: {
    filterProps: {
      handler () {
        this.debouncedSearch()
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    ...mapGetters(['serviceTypes'])
  },
  async created () {
    Geo.getCountries(
      JSON.stringify([{ property: 'withServices', value: '1' }])
    ).then(response => {
      this.countries = response.data.data
    })
    this.debouncedSearch = this.$_.debounce(this.prepareAndEmitFilters, 500)
    this.getServiceTypes()
    let users = await ReservationPerson.getReservationUsers()
    if (users.data.success) {
      this.users = users.data.data
    }
  },
  methods: {
    async getServiceTypes () {
      await this.$store.dispatch('getServiceTypes')
    },
    resetForm () {
      this.resetFormKey = !this.resetFormKey
      this.filterProps = {
        dateRangeType: 'creation',
        serviceCode: '',
        serviceTypeId: '',
        reference: '',
        country: '',
        createdFrom: this.dateFrom,
        createdUntil: this.dateUntil
      }
    },
    prepareAndEmitFilters () {
      let filters = []
      const copiedFilters = { ...this.filterProps }
      if (copiedFilters.dateRangeType === 'departure') {
        copiedFilters.dateFrom = copiedFilters.createdFrom
        copiedFilters.dateUntil = copiedFilters.createdUntil
        delete copiedFilters.createdFrom
        delete copiedFilters.createdUntil
      }
      Object.keys(copiedFilters).forEach(filterProp => {
        if (filterProp !== 'dateRangeType' && copiedFilters[filterProp]) {
          let f = {
            property: `${filterProp}`,
            value: `${copiedFilters[filterProp]}`
          }
          filters.push(f)
        }
      })
      this.$emit('filtersUpdated', filters)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .vc-shadow {
  border: none;
  background-color: #f7fafc;
  box-shadow: none;
  color: #008cdd;
  font-family: 'Open Sans Semibold';
  font-size: 14px;
}

.light-background {
  .right-chevron {
    line-height: 35px;
  }
  background-color: #f7fafc;
}

.type-selection {
  font-family: 'Open Sans Italic';
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/TotalRevenueReports.vue